// FILECONTENT_START src/common/modules/theme/useThemeProps.ts
import { useTheme } from "@mui/material";
import { ThemeExtension } from "./index";

export default function useThemeProps<T = any>(
  props: T,
  key: keyof ThemeExtension["extraComponents"]
): T {
  const theme = useTheme();
  if (!theme.extraComponents) {
    return props;
  }
  let _props = { ...theme.extraComponents[key]?.defaultProps, ...props };
  _props.classes = {
    ...theme.extraComponents[key]?.styleOverrides,
    //@ts-ignore
    ...props.classes,
  };
  return _props;
}

// FILECONTENT_END src/common/modules/theme/useThemeProps.ts